module.exports = __webpack_public_path__ + "static/img/safari.8fce6d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/browsers/safari.png
// module id = OAVQ
// module chunks = 0